import React from 'react';
import AListView from 'antd-mobile/lib/list-view';



export default class ListView extends AListView {}